import React, { useContext } from 'react';
import Content from '../components/content/Content';
import Footer from '../components/footer/Footer';
import AppMenu from '../components/app-menu/AppMenu';
import AppContainer from '../components/app-container/AppContainer';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import ThemeOptionContext from '../context/theme-option/ThemeOptionContext';
import { HashRouter } from 'react-router-dom';
import { ptBR } from '@mui/material/locale';
import { ptBR as ptBRDate } from '@mui/x-date-pickers';
import getSdsThemeOptions from '../theme/sdsThemeOptions';

function App() {
  const { state: themeState } = useContext(ThemeOptionContext);

  const theme = React.useMemo(() => {
    return createTheme(
      getSdsThemeOptions(themeState.isDark ? 'dark' : 'light'),
      ptBR,
      ptBRDate,
    );
  }, [themeState.isDark]);

  return (
    <HashRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppContainer>
          <AppMenu />
          <Content />
          <Footer />
        </AppContainer>
      </ThemeProvider>
    </HashRouter>
  );
}

export default App;